import styled from 'styled-components'

export const DropdownToggleWrapper = styled.div`
  position: relative;
  padding: 0 5px;
  text-align: center;
  border-radius: 5px;
  cursor: pointer;

  // Themed Properties
  ${({ theme }) =>
    theme.functions.mixins.onEvent(`
    box-shadow: none;
    outline: 0;
  `)}
`
